var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.triggerer)?_c('gl-avatar-link',{attrs:{"href":_vm.triggerer.webUrl}},[_c('gl-avatar',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.triggerer.name,"src":_vm.triggerer.avatarUrl,"size":24}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }